module.exports = __webpack_public_path__ + "img/gelato.ca4c6bc6.jpg";